import React, { forwardRef, useImperativeHandle, useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Typography,
} from '@material-ui/core';

import { formatDateDDMMYYYYHHmm } from '../../utils';

// Componente para conteúdo das abas
function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && (
        <Box p={2}>
          <Typography
            style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
          >
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}

const DialogComAbas = forwardRef(({ onClose = () => {} }, ref) => {
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [dados, setDados] = useState({
    retorno: null,
    envio: null,
    erro: null,
  });
  const [venda, setVenda] = useState(null);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  useImperativeHandle(ref, () => ({
    handleOpen(dados, venda) {
      setOpen(true);
      setDados(dados);
      setTab(0);
      setVenda(venda);
    },
  }));

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>Logs NfCe Rejeitada</DialogTitle>

      {/* 🔹 Dados da venda */}
      <div
        style={{
          display: 'flex',
          gap: '2rem',
          padding: '0 1.5rem',
          justifyContent: 'center',
          fontSize: '30px',
        }}
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
            ID:
          </Typography>
          <Typography>{venda?.id}</Typography>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
            Data
          </Typography>
          <Typography>{formatDateDDMMYYYYHHmm(venda?.data)}</Typography>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
            Valor
          </Typography>
          <Typography>R$ {Number(venda?.valor || 0).toFixed(2)}</Typography>
        </div>
      </div>

      <Tabs
        value={tab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label="Erro" />
        <Tab label="Retorno" />
        <Tab label="Envio" />
      </Tabs>

      <DialogContent dividers>
        <TabPanel value={tab} index={0}>
          {dados.erro}
        </TabPanel>

        <TabPanel value={tab} index={1}>
          {dados.retorno}
        </TabPanel>

        <TabPanel value={tab} index={2}>
          {dados.envio}
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
});

export default DialogComAbas;
